import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./ChangePasswordForm";
import {cancelChangePassword} from "../../actions/OnboardingApiActions";
import {Map} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "password");
  return errors.toJS();
}

class ChangePasswordFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("customerId", this.props.customerId);
    return this.props.changeMigrationPassword(updatedValues.toJS())
      .then((response) => {
        if (response.data.changeMigrationPassword.errors.length <= 0) {
          this.props.cancelChangePassword();
        } else {
          let errors = createValidationErrors(response.data.changeMigrationPassword.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelChangePassword();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const CHANGE_MIGRATION_PASSWORD = gql`
  mutation changeMigrationPassword($data: MigrationPasswordInput!) {
    changeMigrationPassword(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(CHANGE_MIGRATION_PASSWORD, {
    props: ({ mutate }) => ({
      changeMigrationPassword: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default connect(null, {cancelChangePassword})(withQueries(ChangePasswordFormContainer));